import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('customers', storeModule.createStoreModule('customers'))
